import "./App.css";
import { Provider, useSelector } from "react-redux";
import store from "./lib/createStore";
import { AppRoutes } from "./navigator";
import { AppProvider } from "./providers/app";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from 'react';
import AlertRotateModal from "./components/alertRotateModal";

function App() {

  const [show, setShow] = useState(false);

  useEffect(() => {
    const firstCheck = () => {
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      const isWidthGreater = window.innerWidth > window.innerHeight;
      if (isWidthGreater && isMobile) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    setTimeout(() => {
      firstCheck();
     }, 1000);

     const handleOrientationChange = () => {
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      const isLandscape = window.matchMedia("(orientation: landscape)").matches;
      if (isMobile && isLandscape) {
        setShow(true);
      } else {
        setShow(false);
      }
    };


    window.addEventListener('resize', handleOrientationChange);
    window.addEventListener('orientationchange', handleOrientationChange);


    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return (
    <AppProvider>
      <Provider store={store}>
        <AppRoutes />
        <ToastContainer/>
        {(show) && (
          <AlertRotateModal
            modalIsOpen={show}
            handleClickOnNo={() => {
              setShow(false);
            }}
            handleClickOnyes={() => {
              setShow(false);
            }}
          />
        )}
      </Provider>
    </AppProvider>
  );
}

export default App;
